import React from 'react';
import { SvgIcon } from '@mui/material';
import HeadphonesIcon from '@mui/icons-material/Headphones';

export const CalculatorIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path 
      fill="#FF6B6B" 
      d="M19,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z M13.03,7.06L14.09,6l1.41,1.41L16.91,6l1.06,1.06l-1.41,1.41l1.41,1.41l-1.06,1.06L15.5,9.54l-1.41,1.41l-1.06-1.06l1.41-1.41L13.03,7.06z M6.25,7.72h5v1.5h-5V7.72z M11.5,16h-2v2h-1.5v-2h-2v-1.5h2v-2H9.5v2h2V16z M18,17.25h-5v-1.5h5V17.25z M18,14.75h-5v-1.5h5V14.75z"
    />
  </SvgIcon>
);

export const TargetIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path 
      fill="#996CFE" 
      d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M12,6A6,6 0 0,0 6,12A6,6 0 0,0 12,18A6,6 0 0,0 18,12A6,6 0 0,0 12,6M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10Z"
    />
  </SvgIcon>
);

export const CalendarIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path 
      fill="#5BC0DE" 
      d="M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1M17,12H12V17H17V12Z"
    />
  </SvgIcon>
);

export const ListeningIcon = (props) => (
  <HeadphonesIcon htmlColor="#996CFE" {...props} />
);

export const ReadingIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path 
      fill="#FF9800" 
      d="M19,2L14,6.5V17.5L19,13V2M6.5,5C4.55,5 2.45,5.4 1,6.5V21.16C1,21.41 1.25,21.66 1.5,21.66C1.6,21.66 1.65,21.59 1.75,21.59C3.1,20.94 5.05,20.5 6.5,20.5C8.45,20.5 10.55,20.9 12,22C13.35,21.15 15.8,20.5 17.5,20.5C19.15,20.5 20.85,20.81 22.25,21.56C22.35,21.61 22.4,21.59 22.5,21.59C22.75,21.59 23,21.34 23,21.09V6.5C22.4,6.05 21.75,5.75 21,5.5V19C19.9,18.65 18.7,18.5 17.5,18.5C15.8,18.5 13.35,19.15 12,20V6.5C10.55,5.4 8.45,5 6.5,5Z"
    />
  </SvgIcon>
);

export const WritingIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path 
      fill="#4CAF50" 
      d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z"
    />
  </SvgIcon>
);

export const SpeakingIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path 
      fill="#2196F3" 
      d="M12,2A3,3 0 0,1 15,5V11A3,3 0 0,1 12,14A3,3 0 0,1 9,11V5A3,3 0 0,1 12,2M19,11C19,14.53 16.39,17.44 13,17.93V21H11V17.93C7.61,17.44 5,14.53 5,11H7A5,5 0 0,0 12,16A5,5 0 0,0 17,11H19Z"
    />
  </SvgIcon>
);
